@if (config) {
  <!-- todo: classes on section: --has-image-checklist -->
  <section
    class="exercise-task"
    [ngClass]="{
      '--has-bookmarking': !config.hide_bookmarking,
      '--has-assistance': config.question_hint,
      '--has-header-image': config.image_uid,
    }"
  >
    <!--* question elements *-->

    <header class="exercise-task__header">
      <div class="exercise-task__question-container">
        @if (!config.hide_bookmarking) {
          <button
            mat-icon-button
            class="m3-icon-toggle-button exercise-task__bookmark-toggle-button"
            (click)="toggleBookmark()"
            [ngClass]="{ '--selected': isBookmarked }"
          >
            <mat-icon [ngClass]="{ 'fill-1': isBookmarked }">{{
              isBookmarked ? 'bookmark_added' : 'bookmark_add'
            }}</mat-icon>
          </button>
        }
        <div class="exercise-task__question">
          @if (config.question_number) {
            <div class="d-flex flex-column">
              @if (showQuestionNumber) {
                <div class="number">
                  {{ 'question' | translate }}
                  {{ config.question_number }}
                </div>
              }
              {{ config.question_text }}
            </div>
          }
          @if (!config.question_number) {
            {{ config.question_text }}
          }
        </div>

        @if (config.question_hint || config.image_hint_uid) {
          <button
            mat-mini-fab
            color="primary"
            class="assistance-button--xs"
            (click)="openQuestionHintDialog()"
            [matTooltip]="'assistance' | translate"
          >
            <mat-icon>help</mat-icon>
          </button>
          <button
            mat-fab
            color="primary"
            class="assistance-button--sm"
            (click)="openQuestionHintDialog()"
            [matTooltip]="'assistance' | translate"
          >
            <mat-icon>help</mat-icon>
          </button>
          <button
            mat-fab
            extended
            color="primary"
            class="assistance-button"
            (click)="openQuestionHintDialog()"
          >
            <mat-icon>help</mat-icon>
            {{ 'assistance' | translate }}
          </button>
        }
      </div>
      <!-- todo: frage mit bild -->
      <!-- ! wenn freigestelltes motiv mit transparentem background: klasse --is-isolated auf img-tag -->
      <!-- <div class="exercise-task__header-image">
      <img src="./../../../assets/images/sample/image-question/karausche.png" class="--is-isolated" alt="" />
    </div> -->
      @if (config.image_uid) {
        <div class="exercise-task__header-image">
          @if (resultData?.image_result_uid && resultMode) {
            <!-- <img
              [src]="baseUrl + resultData?.image_result_uid"
              class="--is-isolated --result-image"
              (load)="resultImgLoaded = true"
              [class.--hidden]="!resultImgLoaded"
              alt=""
            /> -->
            <srcset-image
              [src]="baseUrl + resultData?.image_result_uid"
              class="img --is-isolated --result-image"
              [class.--hidden]="!resultImgLoaded"
              [srcsets]="['sm', 'md', 'lg']"
              alt=""
              (onLoad)="resultImgLoaded = true"
            />
          }
          <!-- <img
            [src]="baseUrl + config.image_uid"
            class="--is-isolated"
            [class.--hidden]="resultImgLoaded"
            alt=""
          /> -->
          <srcset-image
            [src]="baseUrl + config.image_uid"
            class="img --is-isolated"
            [class.--hidden]="resultImgLoaded"
            [srcsets]="['sm', 'md', 'lg']"
            alt=""
          />
        </div>
      }
    </header>

    <!--* answer elements *-->

    <div class="exercise-task__content">
      @switch (config.questiontype) {
        @case ('MC') {
          <ng-container *ngTemplateOutlet="checkboxQuestions"></ng-container>
        }
        @case ('SC') {
          <ng-container *ngTemplateOutlet="checkboxQuestions"></ng-container>
        }
        @case ('FREE') {
          <ng-container *ngTemplateOutlet="freetextQuestions"></ng-container>
        }
        @case ('FREE_SC') {
          <ng-container *ngTemplateOutlet="freetextQuestions"></ng-container>
        }
      }
      <ng-template #checkboxQuestions>
        @if (answersWithQuestions) {
          <ul class="image-checklist">
            @for (answer of answers; track $index) {
              <li
                class="image-checklist__item"
                [ngClass]="{ '--no-img': !answer.image_uid }"
                matRipple
              >
                @if (!resultMode) {
                  <mat-checkbox
                    color="primary"
                    [(ngModel)]="answersModel[$index]"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onAnswerChange($index)"
                  >
                    @if (answer.image) {
                      <srcset-image
                        [src]="baseUrl + answer.image.image_uid"
                        [srcsets]="['sm', 'md', 'lg']"
                        alt=""
                      />
                    }
                    {{ answer.answer }}
                  </mat-checkbox>
                } @else {
                  @if (resultMode!) {
                    <mat-checkbox
                      [color]="!answer.is_correct ? 'error' : 'success'"
                      [checked]="answer.is_checked"
                      (click)="preventChange($event)"
                      [ngClass]="{
                        'checkbox-correct-answer':
                          resultMode && answer.is_correct,
                        'checkbox-wrong-answer':
                          resultMode && !answer.is_correct,
                      }"
                      [disabled]="resultMode"
                    >
                      @if (answer.image) {
                        <srcset-image
                          [src]="baseUrl + answer.image.image_uid"
                          [srcsets]="['sm', 'md', 'lg']"
                          alt=""
                        />
                      }
                      {{ answer.answer }}
                    </mat-checkbox>
                  }
                }
              </li>
            }
          </ul>
        } @else {
          <ul class="checklist">
            @for (answer of answers; track $index) {
              <li class="checklist__item">
                @if (!resultMode) {
                  <mat-checkbox
                    color="primary"
                    [(ngModel)]="answersModel[$index]"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onAnswerChange($index)"
                  >
                    {{ answer.answer }}
                  </mat-checkbox>
                } @else {
                  @if (resultMode!) {
                    <mat-checkbox
                      [color]="!answer.is_correct ? 'error' : 'success'"
                      [checked]="answer.is_checked"
                      (click)="preventChange($event)"
                      [ngClass]="{
                        'checkbox-correct-answer':
                          resultMode && answer.is_correct,
                        'checkbox-wrong-answer':
                          resultMode && !answer.is_correct,
                      }"
                      [disabled]="resultMode"
                    >
                      {{ answer.answer }}
                    </mat-checkbox>
                  }
                }
              </li>
            }
          </ul>
        }
      </ng-template>
      <ng-template #freetextQuestions>
        <div class="free-text">
          <form (ngSubmit)="solveQuestion()">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'your_answer' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="freeTextAnswer"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="handleAnswerInputChange()"
                [disabled]="answers != undefined"
                #inputCtrl="ngModel"
              />
              <mat-hint
                *ngIf="secondAnswerMode && !resultMode"
                class="mat-mdc-form-field-error"
              >
                {{ 'exercise_task_assesment_first_attempt_false' | translate }}
              </mat-hint>
            </mat-form-field>
          </form>
        </div>
        @if (config.questiontype == 'FREE_SC' && answers) {
          <ng-container *ngTemplateOutlet="checkboxQuestions"></ng-container>
        }
      </ng-template>
      <!-- 
      <mat-form-field>
        <input matInput [(ngModel)]="inputValue" name="inputValue" #inputCtrl="ngModel" required>
        <mat-error *ngIf="inputCtrl.invalid && (inputCtrl.dirty || inputCtrl.touched)">
          Bitte geben Sie einen Wert ein.
        </mat-error>
      </mat-form-field> -->

      <!-- todo: multiple choice bild antworten -->
      <!-- ! wenn freigestelltes motiv mit transparentem background: klasse --is-isolated auf img-tag -->
      <!-- <ul class="image-checklist">
      <li class="image-checklist__item --checked" matRipple>
        <mat-checkbox color="secondary">
          <img
            src="./../../../assets/images/sample/image-answer/aland.png"
            class="--is-isolated"
            alt=""
            />
        </mat-checkbox>
      </li>
      <li class="image-checklist__item" matRipple>
        <mat-checkbox color="secondary">
          <img
            src="./../../../assets/images/sample/image-answer/doebel.png"
            class="--is-isolated"
            alt=""
            />
        </mat-checkbox>
      </li>
      <li class="image-checklist__item" matRipple>
        <mat-checkbox color="secondary">
          <img
            src="./../../../assets/images/sample/image-answer/rotfeder.png"
            class="--is-isolated"
            alt=""
            />
        </mat-checkbox>
      </li>
    </ul> -->
    </div>

    @if (!config.hide_solve_button) {
      <footer class="exercise-task__actions">
        @if (!resultMode) {
          <button
            mat-flat-button
            [disabled]="disableSolveButton"
            (click)="solveQuestion()"
          >
            <!-- <mat-icon>check</mat-icon> -->
            {{ (deferSubmit ? 'Next' : 'Solve_task') | translate }}
          </button>
        } @else {
          @if (!onlyOneQuestion) {
            <button mat-flat-button (click)="nextQuestion()">
              <!-- <mat-icon>arrow_forward</mat-icon> -->
              {{ 'Next' | translate }}
            </button>
          }
        }
      </footer>
    }
    @if (solvedCorrect) {
      <footer class="exercise-task__assessment--correct">
        <mat-icon class="fill-1">check_circle</mat-icon>
        <div>
          {{ 'Exercise_task_assesment_correct' | translate }}
        </div>
      </footer>
    }
    @if (solvedInCorrect && resultMode) {
      <footer class="exercise-task__assessment--false">
        <mat-icon class="fill-1">cancel</mat-icon>
        <div>
          {{ 'exercise_task_assesment_false' | translate }}
        </div>
      </footer>
    }
  </section>
}
